import React, { useEffect, useState } from 'react';
import { Redirect } from "react-router-dom";
import HeaderLogo from './HeaderLogo';
import Navbar from './HeaderNavbar';
import { usePopup } from '../../context/PopupContext';
import { DASHBOARD_LINK, POPUP_TYPES, APP_DOMAIN } from '../../constants/constants';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import WpAPI from '../../WpApi';
const HeaderTraditional = (props) => {
    const popupbox = usePopup();
    const history = useHistory();
    const [redirect, setRedirect] = useState(false);
    useEffect(() => {
        popupbox.configurePopup(POPUP_TYPES);
    }, []);
    const redirectTo = (path) => {
        //history.push(path)
        window.location.href = `${APP_DOMAIN}/${path}`
    }
    if (redirect) return <Redirect to={DASHBOARD_LINK} />
    return (<>
        <div className="traditional-left">
            <div className="block-left">
                <HeaderLogo clickAction={(e) => WpAPI.isLoggedIn() && popupbox.show('exit', null, () => (props.saveResume() || setRedirect(true)))} />
            </div>
        </div>
        <div className="traditional-right">
            <Navbar />
        </div>
    </>);
}

export default HeaderTraditional;